<template>
    <div class="container pt-2">
        <PageTitle main="Subcategorias" sub="Cadastrar, alterar ou deletar Subcategorias" />
        <b-form>
            <input id="subcategoria-id" type="hidden" v-model="subcategoria.id" />
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Categoria:" label-for="subcategoria-categoria">
                        <b-form-select id="subcategoria-categoria" :options="categorias"
                            v-model="subcategoria.categoria"
                            placeholder="Informe categoria."
                            :class="{ 'inputError': $v.subcategoria.categoria.$error }"
                            @keydown.tab="$v.subcategoria.categoria.$touch"/>
                        <span class="error" v-if="!$v.subcategoria.categoria.required && $v.subcategoria.categoria.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Titulo:" label-for="subcategoria-titulo">
                        <b-form-input id="subcategoria-titulo" type="text"
                            v-model="subcategoria.titulo"
                            :class="{ 'inputError': $v.subcategoria.titulo.$error }"
                            @keydown.tab="$v.subcategoria.titulo.$touch"/>
                        <span class="error" v-if="!$v.subcategoria.titulo.required && $v.subcategoria.titulo.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.subcategoria.titulo.minLength && $v.subcategoria.titulo.$error">Precisa ter no mínimo 2 letras!</span>
                    </b-form-group>
                </div>
            </div>
            <b-button variant="outline-success" class="btn-custom" @click="save">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 btn-custom" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-subcategorias" 
                class="text-center table table-sm" 
                :items="subcategorias" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadSubcategoria(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-subcategorias"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-subcategorias" 
                class="text-center table table-sm" 
                :items="subcategorias" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadSubcategoria(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-subcategorias"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mask } from 'vue-the-mask'
import { required, minLength } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'subcategorias',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            subcategoria: {},
            subcategorias: [],
            categoria: {},
            categorias: [],
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            fields: [
                { key: 'categoria_titulo', label: 'Categoria', sortable: true },
                { key: 'titulo', label: 'Titulo', sortable: true },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' } }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    validations: {
        subcategoria: {
            titulo: {
                required,
                minLength: minLength(2)
            },
            categoria: {
                required
            }
        }
    },
    computed: {
        rows() {
            return this.subcategorias.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        loadCategorias() {
            const url = `${baseApiUrl}/backend/SELECT/categorias.php`
            axios.get(url).then(res => {
                this.categorias = res.data.map(categoria => {
                    return { ...categoria, value: categoria.id, text: categoria.titulo }
                })
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        loadSubcategorias() {
            const url = `${baseApiUrl}/backend/SELECT/subcategorias.php`
            axios.get(url).then(res => {
                this.subcategorias = res.data
                this.exibeRodape = false
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.exibeRodape = true
            })
        },
        reset() {
            this.subcategoria = {}
            this.loadSubcategorias()
            this.$v.subcategoria.$reset()
        },
        save() {
            this.$v.subcategoria.$touch()
            if(!this.$v.subcategoria.$error){
                const method = this.subcategoria.id ? 'put' : 'post'
                const id = this.subcategoria.id ? `?id=${this.subcategoria.id}` : ''
                if(method==='post'){
                    axios['post'](`${baseApiUrl}/backend/INSERT/subcategorias.php${id}`, this.subcategoria)
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Subcategoria inserida com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                } else {
                    axios['put'](`${baseApiUrl}/backend/UPDATE/subcategorias.php${id}`, this.subcategoria)
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Subcategoria alterada com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                }
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(subcategoria) {
            const sure = confirm("Deseja realmente excluir a subcategoria?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/DELETE/subcategorias.php`
                axios.delete(url, { data: subcategoria })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Subcategoria excluída com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadSubcategoria(subcategoria) {
            this.subcategoria = { ...subcategoria }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.nivel !== 'admin') {
            this.$router.push('/')
        }
        this.loadCategorias()
        this.loadSubcategorias()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.subcategorias.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

#subcategoria-titulo, #subcategoria-categoria {
    /* border: 0; */
    outline: 0;
    border-radius: 10px;
    /* border-bottom: 1px solid #AAA; */
    background-color: rgba(255,255,255,0.4);
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.text-custom {
    font-size: 0.8rem;
}

.btn-custom {
    border-radius: 10px;
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
    background-color: rgba(255,255,255,0.4);
}
</style>